import {AuthModel} from '../../../../auth/core/_models'
import {isOnPremisesInstallation} from '../../../../auth/core/onPremisesAccess'

/**
 * Every user working in a business sees the announcement. A support operator inside a customer's
 * panel is not the customer, and an on-premises installation has its own pages.
 */
export const shouldAnnouncePrintPage = (user?: AuthModel | null) =>
  Boolean(user && !user.support && Number(user.cpi || 0) > 0 && !isOnPremisesInstallation(user))
